import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import Check from '@mui/icons-material/Check';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

import { gray100, primaryButtonOutlinedColor } from '../../../constants/Colors';
import { headerHeight, spHeaderHeight } from '../../../constants/Location';

import Header from '../../uiParts/Header';
import CustomSnackbar from '../../uiParts/CustomSnackbar';
import CustomHead from '../CustomHead';

const styles = {
  checkIcon: {
    '@media screen and (max-width:600px)': {
      fontSize: '64px'
    },
    fontSize: '80px',
    width: '100%'
  },
  container: {
    '@media screen and (max-width:600px)': {
      height: `calc( 100vh - ${spHeaderHeight} - 64px)`,
      m: `${spHeaderHeight} auto 0`,
      pt: '64px',
      width: '90%'
    },
    height: `calc( 100vh - ${headerHeight} - 96px )`,
    m: `${headerHeight} auto 0`,
    pt: '96px',
    width: '560px'
  },
  text: {
    color: gray100,
    mt: '24px',
    textAlign: 'center'
  },
  primaryButtonOutlinedColor,
  title: {
    color: gray100,
    fontSize: '24px',
    fontWeight: '500',
    mt: '16px',
    textAlign: 'center'
  }
};

const ContactComplete: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [open, setOpen] = useState<boolean>(false);
  const [errorText, setErrorText] = useState<string>('');
  const [isLogin, setIsLogin] = useState<boolean>(false);

  const browserBackAlert = (e: { preventDefault: () => void }): void => {
    e.preventDefault();
    setOpen(true);
    setErrorText('前のページには戻れません');
    window.history.pushState(null, '', window.location.pathname);
  };

  useEffect(() => {
    setIsLogin(location.state?.isLogin);
    history.pushState(null, '', window.location.href);
    window.addEventListener('popstate', browserBackAlert);
    return () => {
      window.removeEventListener('popstate', browserBackAlert);
    };
  }, []);

  return (
    <>
      <CustomHead title="お問い合わせ完了 | CMCOS[コムコス]" />
      <Header />
      <Typography component="div" sx={styles.container}>
        <Check sx={styles.checkIcon} />
        <Typography sx={styles.title}>お問い合わせが完了しました</Typography>
        <Typography sx={styles.text}>
          回答まで3営業日ほどお待ち下さい。
          <br />
          回答はメールでお送りいたします。
        </Typography>
        <Button
          fullWidth
          onClick={() => {
            isLogin
              ? navigate('/home')
              : (window.location.href = process.env
                  .REACT_APP_NEXT_JS_BASE_URL as string);
          }}
          sx={[styles.primaryButtonOutlinedColor, { mt: '80px' }]}
          variant="outlined"
        >
          {isLogin ? 'ホームへ' : 'TOPへ'}
        </Button>
      </Typography>
      <CustomSnackbar
        autoHideDuration={6000}
        open={open}
        onClose={() => setOpen(false)}
        text={errorText}
      />
    </>
  );
};

export default ContactComplete;
